import "./single.css"

import Singlepost from "../../singlepostcomponenet/singlepost"
export default function Single() {
  return (
    <div className='single'>
            <Singlepost/>
            
    </div>
  )     
}